import { utilBuildings } from "../../../utils/utilBuildings";
import { selectBuildingsWhichProducesResourceIdAvailable } from "../selectors/selectBuildingsWhichProducesResourceIdAvailable";
export var checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone = function (path) { return function (action, state$, dependencies) {
    var state = state$.value;
    var availableBuildings = selectBuildingsWhichProducesResourceIdAvailable(state, action.taskType.resourceId);
    var anyBuildingWithProductionOrConstructionDone = availableBuildings.some(function (building) {
        return utilBuildings.hasFinishedProduction(building) ||
            utilBuildings.hasFinishedConstruction(building);
    });
    return anyBuildingWithProductionOrConstructionDone ? path : undefined;
}; };



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/checks/checkAnyBuildingWhichProducesResourceIdProductionDoneOrConstructionDone.ts
// module id = 896
// module chunks = 3